import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getPreset } from '../textStyle.js';

const TwoColumnComparisonTable = ({ 
  leftColumnTitle = "My Old Product",
  rightColumnTitle = "My New Product", 
  leftColumnImage = null,
  rightColumnImage = null,
  leftItems = [],
  rightItems = [],
  titleStylePreset = 'compareTableTwoColumnColumnTitle',
  itemStylePreset = 'compareTableTwoColumnItemTitle'
}) => {
  return (
    <Box sx={{ my: 4 }}>
      <Grid container spacing={0} sx={{ minHeight: '400px' }}>
        {/* Left Column - Negative Points */}
        <Grid item xs={6}>
          <Paper 
            sx={{ 
              height: '100%',
              borderRadius: '16px 0 0 16px',
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              borderRight: '0.5px solid #e0e0e0',
              p: 3,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {/* Left Column Image */}
            {leftColumnImage && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <img 
                  src={leftColumnImage} 
                  alt={leftColumnTitle}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    borderRadius: '8px'
                  }}
                />
              </Box>
            )}
            
            {/* Left Column Title */}
            <Typography 
              sx={{ 
                mb: 3,
                ...getPreset(titleStylePreset),
                fontFamily: getPreset(titleStylePreset)?.fontFamily || 'inherit',
                fontSize: getPreset(titleStylePreset)?.fontSize || '16px',
                fontWeight: getPreset(titleStylePreset)?.fontWeight || 'bold',
                color: getPreset(titleStylePreset)?.color || '#000',
                textAlign: getPreset(titleStylePreset)?.textAlign || 'center',
                lineHeight: getPreset(titleStylePreset)?.lineHeight || 'inherit',
                letterSpacing: getPreset(titleStylePreset)?.letterSpacing || 'inherit'
              }}
            >
              {leftColumnTitle}
            </Typography>
            
            {/* Left Column Items - Negative Points */}
            <Box sx={{ flexGrow: 1 }}>
              {leftItems.map((item, index) => (
                <Box 
                  key={index} 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    mb: 2,
                    gap: 2
                  }}
                >
                  <CancelIcon sx={{ color: '#dc3545', fontSize: 20, mt: 0.2, flexShrink: 0 }} />
                  <Typography 
                    sx={{
                      ...getPreset(itemStylePreset),
                      fontFamily: getPreset(itemStylePreset)?.fontFamily || 'inherit',
                      fontSize: getPreset(itemStylePreset)?.fontSize || '12px',
                      fontWeight: getPreset(itemStylePreset)?.fontWeight || '500',
                      color: getPreset(itemStylePreset)?.color || '#000',
                      textAlign: getPreset(itemStylePreset)?.textAlign || 'left',
                      lineHeight: getPreset(itemStylePreset)?.lineHeight || '1.4',
                      letterSpacing: getPreset(itemStylePreset)?.letterSpacing || 'inherit'
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* Right Column - Positive Points */}
        <Grid item xs={6}>
          <Paper 
            sx={{ 
              height: '100%',
              borderRadius: '0 16px 16px 0',
              backgroundColor: '#f0f9f0',
              border: '1px solid #e0e0e0',
              borderLeft: '0.5px solid #e0e0e0',
              p: 3,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {/* Right Column Image */}
            {rightColumnImage && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <img 
                  src={rightColumnImage} 
                  alt={rightColumnTitle}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    borderRadius: '8px'
                  }}
                />
              </Box>
            )}
            
            {/* Right Column Title */}
            <Typography 
              sx={{ 
                mb: 3,
                ...getPreset(titleStylePreset),
                fontFamily: getPreset(titleStylePreset)?.fontFamily || 'inherit',
                fontSize: getPreset(titleStylePreset)?.fontSize || '16px',
                fontWeight: getPreset(titleStylePreset)?.fontWeight || 'bold',
                color: getPreset(titleStylePreset)?.color || '#000',
                textAlign: getPreset(titleStylePreset)?.textAlign || 'center',
                lineHeight: getPreset(titleStylePreset)?.lineHeight || 'inherit',
                letterSpacing: getPreset(titleStylePreset)?.letterSpacing || 'inherit'
              }}
            >
              {rightColumnTitle}
            </Typography>
            
            {/* Right Column Items - Positive Points */}
            <Box sx={{ flexGrow: 1 }}>
              {rightItems.map((item, index) => (
                <Box 
                  key={index} 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    mb: 2,
                    gap: 2
                  }}
                >
                  <CheckCircleIcon sx={{ color: '#28a745', fontSize: 20, mt: 0.2, flexShrink: 0 }} />
                  <Typography 
                    sx={{
                      ...getPreset(itemStylePreset),
                      fontFamily: getPreset(itemStylePreset)?.fontFamily || 'inherit',
                      fontSize: getPreset(itemStylePreset)?.fontSize || '12px',
                      fontWeight: getPreset(itemStylePreset)?.fontWeight || '500',
                      color: getPreset(itemStylePreset)?.color || '#000',
                      textAlign: getPreset(itemStylePreset)?.textAlign || 'left',
                      lineHeight: getPreset(itemStylePreset)?.lineHeight || '1.4',
                      letterSpacing: getPreset(itemStylePreset)?.letterSpacing || 'inherit'
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TwoColumnComparisonTable;